module.exports = __webpack_public_path__ + "a7286ba98b3d77a7a747dc62db8f427f.svg";